import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import apiClient from "../components/apiClient";
import "@ckeditor/ckeditor5-ui/theme/globals/globals.css";
import "@ckeditor/ckeditor5-theme-lark/theme/theme.css";
import DOMPurify from "dompurify";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [aboutContent, setAboutContent] = useState("");

  useEffect(() => {
    const fetchAboutUs = async () => {
      try {
        const response = await apiClient.get("/support/aboutus");
        if (response.data && response.data.length > 0) {
          setAboutContent(response.data[0].aboutus);
        }
      } catch (error) {
        console.error("Failed to fetch About Us content:", error);
      }
    };

    fetchAboutUs();
  }, []);

  return (
    <div className="flex flex-col min-h-screen shadow-lg">
      {/* Main Content */}
      <main className="flex-grow">
        <section className="py-20">
          <div className="mt-8 mx-auto max-w-7xl px-4 sm:px-6 lg:px-4">
            {/* About Us Heading */}

            {/* <h2 className="text-4xl font-bold text-gray-900 leading-7 text-center max-w-6xl mx-auto mb-5">
              THE LEADING STUFF
            </h2>

            <p className="text-lg text-gray-700 leading-7 text-center max-w-6xl mx-auto mb-3">
              Musique is multi-brand company under PT V2 Indonesia.
            </p>
            <p className="text-lg text-gray-700 leading-7 text-center max-w-6xl mx-auto mb-3">
              Created in 2019 Musique selling high end curated audio brand
              around the world. Musique presents the best audio products for
              home cinema, portable audio, and custom installation to fulfill
              customer needs and complement lifestyles.
            </p>
            <p className="text-lg text-gray-700 leading-7 text-center max-w-6xl mx-auto">
              Now, customers can enjoy and experience high quality of audio at
              home.
            </p> */}

            {/* <div
              className="ck-content mt-4 whitespace-pre-wrap text-black"
              dangerouslySetInnerHTML={{ __html: aboutContent }}
            /> */}
            {/* <div className="max-w-4xl mx-auto p-4"> */}
              {/* <h2 className="text-2xl font-semibold mb-4">About Us</h2> */}
              <div
                className="ql-editor"
                dangerouslySetInnerHTML={{ __html: aboutContent }}
              />
            {/* </div> */}
          </div>
        </section>
      </main>

      {/* Footer Stays at Bottom */}
      <Footer />
    </div>
  );
};

export default Accordion;
